export default class Blacklist {
    constructor() {
        this.gameId = 6;
        this.baseUrl = "https://gamification.jdsoftwarellc.com/";
        this.blacklistLocal = ["crazygames.com", "xxlocalhost:3000"];
    }
    ////todo: swtich back to Check() instead of CheckLocal CheckRemote after crazy games have removed cribbage form thair portal
    ///the local is quicker wihtout ads and I can control that code
    async Check() {
        //check local blacklist
        if (this.isBlacklisted(this.blacklistLocal)) return true;

        //check remote blacklist
        let blacklistRemote = await this.GetBlacklist();
        if (this.isBlacklisted(blacklistRemote)) return true;

        return false;
    }
    CheckLocal() {
        //check local blacklist
        if (this.isBlacklisted(this.blacklistLocal)) return true;

        return false;
    }
    async CheckRemote() {
        //check remote blacklist
        let blacklistRemote = await this.GetBlacklist();
        if (this.isBlacklisted(blacklistRemote)) return true;

        return false;
    }
    isBlacklisted(blacklist) {
        if (!blacklist || !Array.isArray(blacklist)) return false;
        let localUrl = window.location.href || "";
        //check if local url is in blacklist
        let isBlacklisted = blacklist.some(function (url) {
            if (!localUrl) return false;
            if (!url) return false;
            //check if url is in blacklist
            let re = new RegExp(url, 'gi');
            if (localUrl.match(re)) {
                return true;
            }
            //check if ancestorOrigins contain url
            if (window.location?.ancestorOrigins?.[0]?.includes(url)) {
                return true;
            }
            return false;
        });
        return isBlacklisted;
    }
    async GetBlacklist(gameId) {
        if (!gameId && gameId != 0) gameId = this.gameId;

        var url = `api/Blacklist/${gameId}`;
        url = this.baseUrl + url;

        let response = await fetch(url, {
            method: "GET",
            headers: {
                "cache-control": "private"
            }
        });
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        const list = await response.json();
        return list;
    };
}
